<template>
  <div class="header">
    <a-carousel :autoplay="false" arrows ref="carousel">
      <img src="../../assets/images/new_banner.jpg" alt="" class="header-img">
      <img src="../../assets/images/background.png" alt="" class="header-img">
    </a-carousel>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  mounted() {
    console.log(this.$refs.carousel);
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  height: 300px;
  position: relative;
  margin: 0 auto;
  // background: url("../../assets/images/background.png") center;
  // background-size: cover;
}
.header-img {
  width: 100%;
  height: 300px;
}
</style>